import { RootState } from "@/store/store";
import { PostUsersMeV2OrganisationsCurrentByTypeResourcesApiResponse } from "@/services/cloudchipr.api";
import { postUsersMeV2OrganisationsCurrentByTypeResourcesSelector } from "@/store/resources-grid/selectors/resource-data/postUsersMeV2OrganisationsCurrentByTypeResourcesSelector";

export const liveUsageResourceMetadataSelector = (
  state: RootState,
  fixedCacheKey: string,
):
  | Omit<
      PostUsersMeV2OrganisationsCurrentByTypeResourcesApiResponse,
      "resources"
    >
  | undefined => {
  return postUsersMeV2OrganisationsCurrentByTypeResourcesSelector(
    fixedCacheKey,
  )(state)?.data;
};
